// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__SmVSe"};